import StatusMsg from '@/components/common/status-msg';
import { SecBoxLoader } from '@/components/layout/sec-box';
import { ScrollArea } from '@mantine/core';
import axios from 'axios';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const MonthlyNetWinChart = ({ className }) => {
    const [error, setError] = useState({ message: '', variant: '' });
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { remoteId } = useSelector((state) => state.session);

    useEffect(() => {
        const getMonthlyNetIncome = async () => {
            try {
                setLoading(true);
                const params = {
                    action: 'monthly-netwin',
                    token: process.env.NEXT_PUBLIC_TOKEN,
                    casino: process.env.NEXT_PUBLIC_CASINO,
                    remote_id: remoteId,
                };

                const response = await axios.get(`${process.env.NEXT_PUBLIC_ADMIN_API_DOMAIN}/casinos/casino-admin-reports`, { params });

                if (response?.data?.data) {
                    const data = response.data.data;
                    const filteredData = data
                        ?.map((e) => {
                            return {
                                ...e,
                                netwinIncome: typeof e.netwinIncome === 'number' ? Number.parseFloat(e.netwinIncome.toFixed(2)) : 0,
                            };
                        })
                        .reverse();
                    setChartData(filteredData);
                } else {
                    setError({ message: response?.message, variant: 'danger' });
                }
            } catch (error) {
                setError({ message: error.message, variant: 'danger' });
            } finally {
                setLoading(false);
            }
        };

        getMonthlyNetIncome();
    }, [remoteId]);

    return (
        <div className={clsx(className, 'h-full')}>
            {loading ? (
                <SecBoxLoader />
            ) : error?.message ? (
                <div className="full_screen_msg sec_box_msg">
                    <StatusMsg title={error?.message} variant={error?.variant} />
                </div>
            ) : (
                <ScrollArea type="always" offsetScrollbars scrollbars="x" className={'sec_box_chart_scroll'}>
                    <div style={{ minWidth: '21.875rem', height: '100%' }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 40 }}>
                                <defs>
                                    <linearGradient id="netWinGradient" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="var(--success-color)" stopOpacity={0.5} />
                                        <stop offset="95%" stopColor="var(--success-color)" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" stroke="var(--chart-grid-color)" />
                                <XAxis
                                    dataKey="monthName"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{
                                        fontSize: 11,
                                        fill: 'var(--chart-axis-color)',
                                        angle: -45,
                                        dx: -10,
                                        dy: 10,
                                        textAnchor: 'end',
                                    }}
                                    interval={0}
                                />
                                <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: 'var(--chart-axis-color)' }} />
                                <Tooltip />

                                <Area
                                    type="monotone"
                                    dataKey="netwinIncome"
                                    stroke="var(--success-color)"
                                    strokeWidth={2}
                                    fill="url(#netWinGradient)"
                                    dot={{
                                        r: 4,
                                        fill: 'var(--success-color)',
                                        stroke: 'var(--success-color)',
                                    }}
                                    activeDot={{
                                        r: 6,
                                        fill: 'var(--success-color)',
                                        stroke: 'var(--success-color)',
                                    }}
                                />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                </ScrollArea>
            )}
        </div>
    );
};

export default MonthlyNetWinChart;
